import { FC } from "react";
import { DialogContent, Divider, Stack } from "@mui/material";
import { usePreviousDifferent } from "rooks";
import { ResourceGridCleanDialogGrid } from "./grid/ResourceGridCleanDialogGrid";
import { ResourceGridCleanDialogConfirmationSection } from "./ResourceGridCleanDialogConfirmationSection";
import { ResourceGridCleanDialogDescription } from "./ResourceGridCleanDialogDescription";
import { ResourceGridCleanDialogExcludedResources } from "./ResourceGridCleanDialogExcludedResources";
import { useAppSelector } from "@/store/hooks";
import { gridResourcesCurrentCleanResourceTypeSelector } from "@/store/resources-grid/selectors/clean/resource-related/gridResourcesCurrentCleanResourceTypeSelector";
import { gridResourcesCurrentCleanResourcesSelector } from "@/store/resources-grid/selectors/clean/resources/gridResourcesCurrentCleanResourcesSelector";

interface CleanV2DialogContentProps {
  cleanInputValue: string;
  onCleanInputChange(value: string): void;
  actionType: string;
}
export const ResourceGridCleanDialogContent: FC<CleanV2DialogContentProps> = ({
  cleanInputValue,
  onCleanInputChange,
  actionType,
}) => {
  const resourceType = useAppSelector(
    gridResourcesCurrentCleanResourceTypeSelector,
  );

  const data = useAppSelector(gridResourcesCurrentCleanResourcesSelector);
  const prevData = usePreviousDifferent(data);
  const gridData = data ?? prevData;

  if (!resourceType) {
    return null;
  }

  return (
    <DialogContent dividers sx={{ pb: 3, p: 0 }}>
      <ResourceGridCleanDialogDescription />

      <Stack px={3} spacing={4} mb={3}>
        <ResourceGridCleanDialogGrid
          resourceType={resourceType}
          data={gridData}
        />

        <ResourceGridCleanDialogExcludedResources />
      </Stack>

      <Divider />

      <ResourceGridCleanDialogConfirmationSection
        cleanInputValue={cleanInputValue}
        onCleanInputChange={onCleanInputChange}
        placeholder={actionType}
      />
    </DialogContent>
  );
};
